<template>
    <div class="markdown-body markdown-container markdown-disable-select" :style="containerStyle">
        <div v-html="html"/>
        <slot />
    </div>
</template>

<script>
import marked from 'marked'

export default {
    name: "Markdown",
    props: [
        "markdown",
        "containerStyle"
    ],
    computed: {
        html: function() {
            if (!this.markdown) {
                return;
            }
            return marked(this.markdown, { sanitize: true });
        }
    }
}
</script>

<style scoped>
    .markdown-container {
        padding: 15px 15px 0px 15px;
    }
    .markdown-disable-select {
        -webkit-touch-callout: none;  
        -webkit-user-select: none;  
        -khtml-user-select: none;  
        -moz-user-select: none;  
        -ms-user-select: none;  
        user-select: none;  
    }
</style>
